import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choice", "messageFields", "message", "submit"]

  connect() {
    this.update()
  }

  update() {
    const selectedChoice = this.choiceTargets.find(choice => choice.checked)
    const messageRequired = selectedChoice?.value === "0"

    this.messageFieldsTarget.hidden = !messageRequired
    this.messageTarget.required = messageRequired
    this.messageTarget.disabled = !messageRequired
    this.submitTarget.disabled = !selectedChoice || (messageRequired && !this.messageTarget.value.trim())
  }
}
